<template>
	<div class="space-y-6">
		<!-- Header Section -->
		<div class="space-y-4">
			<div class="space-y-2">
				<h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100">
					{{ $t('onboarding.setPrizeTitle') }}
				</h2>
				<div class="space-y-2 text-gray-700 dark:text-gray-300">
					<p>{{ $t('onboarding.setPrizeStep.description') }}</p>
					<Message severity="info" class="mb-4">
						<div class="space-y-3">
							<p class="font-medium">{{ $t('onboarding.setPrizeStep.howItWorks.title') }}</p>
							<ul class="space-y-2 ml-4">
								<li class="flex items-start">
									<span class="text-blue-600 dark:text-blue-400 font-bold mr-3 mt-0.5">1.</span>
									<span>{{ $t('onboarding.setPrizeStep.howItWorks.step1') }}</span>
								</li>
								<li class="flex items-start">
									<span class="text-blue-600 dark:text-blue-400 font-bold mr-3 mt-0.5">2.</span>
									<span>{{ $t('onboarding.setPrizeStep.howItWorks.step2') }}</span>
								</li>
								<li class="flex items-start">
									<span class="text-blue-600 dark:text-blue-400 font-bold mr-3 mt-0.5">3.</span>
									<span>{{ $t('onboarding.setPrizeStep.howItWorks.step3') }}</span>
								</li>
							</ul>
						</div>
					</Message>
					<p class="text-sm text-gray-600 dark:text-gray-400">
						{{ $t('onboarding.setPrizeStep.managementNote') }}
					</p>
				</div>
			</div>
		</div>
		<div class="grid grid-cols-1 gap-4 mt-4">
			<Message v-if="!filteredPrizeSuggestions.length" severity="info" class="col-span-full">
				{{ $t('onboarding.noMorePrizes') }}
			</Message>
			<PrizeSuggestionCard v-for="prize in filteredPrizeSuggestions" :key="prize.description!" :prize="prize"
				v-model="prize.selected" />
		</div>
		<div class="flex mt-4 justify-between">
			<Button @click="$emit('back')" variant="outlined">
				{{ $t('onboarding.buttons.back') }}
			</Button>
			<Button @click="handleNext">
				{{ selectedSuggestions.length ?
					$t('onboarding.buttons.addSelected', { count: selectedSuggestions.length }) :
					$t('onboarding.buttons.finish')
				}}
			</Button>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { NewPrizeSuggestion } from "@/types/prize";
import Button from 'primevue/button';
import { computed, ref, type Ref } from "vue";
import PrizeSuggestionCard from './PrizeSuggestionCard.vue';
import { usePrizeSettingsStore } from "@/stores";
import { storeToRefs } from "pinia";

const { createPrizeSuggestion } = usePrizeSettingsStore();
const { prizeSuggestions } = storeToRefs(usePrizeSettingsStore());
const emit = defineEmits<{
	(e: 'next', suggestions: string[]): void
	(e: 'back'): void
}>();
const selectedSuggestions = computed(() => prizeSuggestionTemplates.value.filter(c => c.selected));

const filteredPrizeSuggestions = computed(() => {
	return prizeSuggestionTemplates.value.filter(suggestion => !prizeSuggestions.value.some(s => s.description === suggestion.description));
});
const prizeSuggestionTemplates: Ref<NewPrizeSuggestion[]> = ref([
	{
		description: "Essen gehen 🍔🍡🥗",
		selected: false
	},
	{
		description: "Kinobesuch 🍿🎬",
		selected: false
	},
	{
		description: "Filmabend 🛋️📺",
		selected: false
	},
	{
		description: "Wellness-Tag 🧖‍♀️💆‍♂️",
		selected: false
	},
	{
		description: "Bekocht werden 🍽️👩‍🍳👩‍🍳",
		selected: false
	},
	{
		description: "Massage 💆‍♀️💆‍♂️",
		selected: false
	},
	{
		description: "Spieleabend 🎲🎮",
		selected: false
	},
	{
		description: "Frühstück ans Bett 🥐☕",
		selected: false
	},
	{
		description: "Ein Kasten Bier/Getränk nach Wahl 🍻",
		selected: false
	}
]);

const handleNext = async () => {
	emit('next', selectedSuggestions.value.map(s => s.description!));
};

</script>
